"use strict";

module.exports = {
    stringify: function stringify(url, data) {
        if (!data) {
            return url;
        }
        var param = [];
        for (var o in data) {
            if (data.hasOwnProperty(o)) {
                param.push(o + "=" + data[o]);
            }
        }
        return ~url.indexOf("?") ? url + '&' + param.join("&") : url + "?" + param.join("&");
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/util/url.js
// module id = 63
// module chunks = 0